/**
 * Valid benefit field names for Individual Disability LOC
 *
 * Used to filter out fields that don't belong to Individual Disability benefits when saving to API.
 * These fields represent the API structure (nested structures).
 */

export const INDIVIDUAL_DISABILITY_VALID_FIELDS = new Set([
  "objectType",
  "benefitDuration",
  "definitionOfDisability",
  "employerContribution",
  "preExistingCondition",
  "ltdPlanDesign",
  "idiPlanDesign",
  "gsiBenefitMaximum",
  "ownOccupationPeriod",
  "eliminationPeriodDays",
  "mentalIllnessBenefit",
  "recoveryBenefit",
  "catastrophicBenefit",
  "portability",
  "benefitClassAvailability",
]);
